import { createSelector } from 'selectors'

import { highlighter } from './constant'

const getLinks = () => createSelector<NodeListOf<HTMLSelectElement>>({ selector: highlighter.selector.link }, true)

export const getHighlighterComponents = () => ({
	links: getLinks(),
})
